import {
  AppLogSortField,
  IAppLogPageRequestParams,
  ILogInfo,
  ILogInfoListResponse,
} from "api/entities/logs";
import Table, { IColumnDefinition } from "components/shared-ui/table/table";
import { Formatters } from "helper/formatters";
import React from "react";
import { AppLogDownloadButton } from "./download";

export interface IAppLogTableProps {
  isLoading: boolean;
  page: ILogInfoListResponse;
  requestParams: IAppLogPageRequestParams;
  setRequestParams: (data: Partial<IAppLogPageRequestParams>) => void;
}

export function AppLogTable(props: IAppLogTableProps) {
  const columns: IColumnDefinition<ILogInfo, AppLogSortField>[] = [
    {
      label: "Service",
      sortKey: AppLogSortField.Container,
      formatter: (row) => row.container,
    },
    {
      label: "Instance",
      sortKey: AppLogSortField.Pod,
      formatter: (row) => row.pod,
    },
    {
      label: "File",
      sortKey: AppLogSortField.File,
      formatter: (row) => row.filename,
    },
    {
      label: "Size",
      sortKey: AppLogSortField.FileSize,
      formatter: (row) => Formatters.formatStorageSpace(row.fileSize),
    },
    {
      label: "Modified at",
      sortKey: AppLogSortField.ModifiedAt,
      formatter: (row) => Formatters.formatUnixTS(row.modifiedAt),
    },
    {
      label: "Download",
      formatter: (row) => (
        <AppLogDownloadButton
          container={row.container}
          fileName={row.filename}
          namespace={row.namespace}
          pod={row.pod}
          podId={row.podId}
          podIp={row.podIp}
        />
      ),
    },
  ];

  return (
    <Table
      testId="app-log-table"
      hideCheckbox={true}
      columns={columns}
      rows={props.page.data}
      totalRows={props.page.total}
      loading={props.isLoading}
      requestParams={props.requestParams}
      onRequestParamsChanged={props.setRequestParams}
      responsive={true}
    />
  );
}
